"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LwtApp = void 0;
const react_1 = __importDefault(require("react"));
const hooks_1 = require("../@common/hooks");
const i18n_util_1 = require("../@common/util/i18n-util");
const LwtStoreProvider_1 = require("./LwtStoreProvider");
const LwtApp = (_a) => {
    var { api, i18n = {} } = _a, props = __rest(_a, ["api", "i18n"]);
    const { Component: UnsupportedVersion } = (0, hooks_1.useAppVersion)();
    if (UnsupportedVersion)
        return react_1.default.createElement(UnsupportedVersion, null);
    return (react_1.default.createElement(i18n_util_1.LwtI18nProvider, { i18n: (0, i18n_util_1.initI18n)(i18n) },
        react_1.default.createElement(LwtStoreProvider_1.LwtStoreProvider, Object.assign({}, api), props.children)));
};
exports.LwtApp = LwtApp;
exports.default = exports.LwtApp;
